export default "__VITE_ASSET__BkhjJ3vK__"